import {
	type ApiErrorResponse,
	disableNotificationInterceptors,
	type PostFanShopCheckoutStartData
} from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { fanShopApi } from '../api';

type UseProductCheckoutStartQueryProps = {
	productVariantId: string;
	quantity: number;
};

export const UseProductCheckoutStartQueryKey = ['checkout-start'] as const;

export const useProductCheckoutStartQuery = () => {
	return useMutation<
		PostFanShopCheckoutStartData,
		AxiosError<ApiErrorResponse>,
		UseProductCheckoutStartQueryProps,
		unknown
	>({
		mutationFn: async ({ productVariantId, quantity }: UseProductCheckoutStartQueryProps) =>
			(await fanShopApi).postFanShopCheckoutStart(
				{},
				{ productVariantId, quantity },
				{ customErrorInterceptor: disableNotificationInterceptors }
			),
		mutationKey: UseProductCheckoutStartQueryKey
	});
};
